import moment from 'moment';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ProductAction } from '../../actions';
import { RayTable } from '../../components/common';
import { Translate as t } from '../../config/Translate';
import ImportResultSummary, { buildImportSummary } from '../../components/common/ImportResultSummary';

const AdminTenYears = ({ BulkUpdateEachProductTenYearsWarranty, companies, clist }) => {
	const [view, setView] = useState("raw");
	const [rawData, setRawData] = useState("");
	const [list, setList] = useState([]);
	const [col, setCols] = useState([]);
	const [codeList, setCodeList] = useState([]);
	const [subtitle, setSubTitle] = useState("");
	const [appliable, setAppliable] = useState(false);
	const [importSummary, setImportSummary] = useState(null);
	const [reason, setReason] = useState("");
	const [processError, setProcessError] = useState("");
	const [progress, setProgress] = useState({ done: 0, total: 0 });
	const [times, setTimes] = useState([]);

	const updateColumnName = "S/N";
	const updateColumnNameShip = "SN";

	const CHUNK_SIZE = 20;

	const options = {
		filterColumns: []
	}

	useEffect(() => {
		setCodes();
	}, [clist]);

	useEffect(() => {
		if (codeList.length > 0)
			setTimes(codeList.filter(x => x.datatype == "DATETIME").map(y => y.code));
	}, [codeList])


	const setCodes = () => {
		const codes = Array.isArray(clist) ? clist : []; // BUG-157: 비배열 가드
		console.log('AdminTenYears setCodes -> ', codes.filter(x => x.type === 'PRODUCTEXTRAKEY'));
		const list = codes.filter(x => x.type === 'PRODUCTEXTRAKEY');
		list.push({ code: 'installedDate', name: "Installeddate", alias: ["설치일"] });
		list.push({ code: "shipmentdate", name: "Shipmentdate", alias: ["선적일"] });
		setCodeList(list);
	}

	const process = async () => {
		setProcessError("");
		setImportSummary(null);
		setView("process");
		let plist = [...list];
		plist.map(x => {
			times.map(t => {
				if (x.hasOwnProperty(t)) {
					x[t] = moment(x[t]).valueOf()
				}
			})
			return x;
		})

		plist = makeDataforUpdate(plist);

		const chunks = [];
		for (let i = 0; i < plist.length; i += CHUNK_SIZE) {
			chunks.push(plist.slice(i, i + CHUNK_SIZE));
		}

		setProgress({ done: 0, total: plist.length });

		let applied = 0; // 성공한 청크의 누적 건수 (U-43 결과 요약)

		for (const chunk of chunks) {
			const res = await BulkUpdateEachProductTenYearsWarranty(chunk);
			if (!res || res.status !== 'success') {
				console.warn('[AdminTenYears] bulk tenyears warranty chunk failed', {
					handler: 'AdminTenYears.process',
					chunkSize: chunk?.length,
					targetSns: Array.isArray(chunk) ? chunk : [],
					reason: res?.err || 'unknown error',
				});
				const errMsg = res?.err?.errmsg || (typeof res?.err === 'string' ? res.err : '') || "Failed to update devices. Please try again.";
				setProcessError(errMsg);
				setImportSummary(buildImportSummary(plist.length, applied, chunk));
				setView("convert");
				return;
			}
			applied += chunk.length;
			setProgress(prev => ({ done: prev.done + chunk.length, total: plist.length }));
		}

		setImportSummary(buildImportSummary(plist.length, applied, []));
		setView("done");
	}

	const makeDataforUpdate = (plist) => {
		const tmpList = [];
		plist.map(x => {
			const obj = [];
			obj.push(x.sn);// = x.sn;
			tmpList.push(x.sn);
		})
		return tmpList;
	}

	const goPreview = () => {
		setView("convert");
		const lines = rawData.split('\n');
		if (lines.length > 0) {
            manParser();
		}
	};

	const setObject = (header, type) => {
		const columnHeaders = [];

		header.split('\t').map((x, idx) => {
			if (x.trim().toUpperCase() == (type == "MAN" ? updateColumnName : updateColumnNameShip)) {
				columnHeaders.push({
					code: (type == "MAN" ? updateColumnName : updateColumnNameShip),
					idx: idx,
				})
			} else {
				const n = codeList.filter(y =>
					y.name.toUpperCase() == x.trim().toUpperCase() ||
					y.alias.map(m => m.toUpperCase()).includes(x.trim().toUpperCase()));
				if (n.length > 0) {
					columnHeaders.push({
						code: n[0].code,
						idx: idx,
					})
				}
			}
		})
		return columnHeaders;
	}

	const setLine = (headers, item, type) => {
		const tp = (type == "MAN" ? updateColumnName : updateColumnNameShip)
		const obj = {};
		const arr = item.split('\t');
		headers.map((x, idx) => {
			const n = arr.filter((y, hidx) => x.idx == hidx);
			if (n.length > 0) {
				if (arr[x.idx]) {
					if (x.code == tp) {
						if (arr[x.idx] != "")
							obj[x.code == tp ? "sn" : x.code] = arr[x.idx];
					} else {
						obj[x.code == tp ? "sn" : x.code] = arr[x.idx];
					}
				}
			}
		});
		return obj;
	}

	const manParser = () => {
		const nlist = []
		const lines = rawData.split('\n');
		const headers = setObject(lines[0], "MAN");
		const obj = {};
		headers.forEach(x => obj[x.code === "S/N" ? "sn" : x.code] = "");
		setCols(makeCol(obj));
		lines.map((x, idx) => {
			if (idx > 0 && x.trim() != "")
				nlist.push(setLine(headers, x, "MAN"))
		});
		setAppliable(true);
		setList(nlist);
	}

	const titleCase = s => s
		.replace(/(^|[_-])([a-z])/g, (a, b, c) => c.toUpperCase())
		.replace(/([a-z])([A-Z])/g, (a, b, c) => `${b} ${c}`);

	const makeCol = (item) => {
		const nlist = [];
		Object.keys(item).map(y => {
			const keyname = y;
			if (typeof item[y] === "object") {
				Object.keys(item[y]).map(n => {
					nlist.push({ name: y + "." + n, label: titleCase(y) + " " + titleCase(n), type: times.includes(y + "." + n) ? "DT" : "" });
				})
			} else {
				if (keyname == "companyId") {
					nlist.push({
						name: keyname,
						// label: titleCase(keyname),
						label: codeList.find(x => x.code === keyname)?.name,
						options: {
							title: "Assign",
							paramType: 'callback'
						},
						type: "BUTTON"
					});
				} else {
					nlist.push({
						name: keyname,
						// label: titleCase(keyname),
						label: keyname === "sn" ? "S/N" : codeList.find(x => x.code === keyname)?.name,
						type: times.includes(keyname) ? "DT" : ""
					});
				}
			}
		});

		return nlist;
	};

	return (
		<>
			{
				<>
					<div className="extraHeader">
						<h2 className="mb-0">10 {t('common.label.year')} {t('warranty.title')}</h2>
						<div className="ray-right">
						</div>
					</div>
					<div id="appCapsule" className="extra-header-active full-height">
						{view == "raw" && <>
							<div className="section mt-1 mb-1">
								<div className="section-title">
									{t('product.label.writeRawData')}
									<div className="float-end">
										{rawData != "" && <button
											onClick={() => goPreview()}
											className="btn btn-primary">{t('common.button.convert')}</button>}
									</div>
									<div className="clearfix" />
								</div>
								<div className="mt-2">
									<textarea className="form-control" rows="20"
										autoComplete="off" style={{ height: 400 }}
										placeholder={t('product.placeholder.tenYearsRawData')}
										defaultValue={rawData}
										onChange={(e) => setRawData(e.target.value)}></textarea>
								</div>
							</div>
						</>}
						{view == "convert" && <>
							<div className="section mt-1 mb-1">
								<div className="section-title">
									Preview Data - {subtitle}{reason && <> <span className="alert alert-warning">{reason}</span></>}{processError && <> <span className="alert alert-danger">{processError}</span></>}{processError && <ImportResultSummary summary={importSummary} />}
									<div className="float-end">
										<button className="btn btn-secondary me-1" onClick={() => setView("raw")}>{t('common.button.cancel')}</button>
										<button className={appliable ? "btn btn-primary" : "btn btn-primary disabled"} onClick={() => process()}>{t('common.button.apply')}</button>
									</div>
									<div className="clearfix" />
								</div>
							</div>
							<div className="card section mt-1 mb-1 p-3">
								<RayTable
									css="small table table-bordered mb-1"
									onlytable={true}
									data={list}
									columns={col}
									options={options} />
							</div>
						</>}
						{view == "process" && <>
							<div className="section mt-1 mb-1">
								<div className="card">
									<div className="card-body text-center" style={{ padding: 60 }}>
										<h3>Please wait a minute...</h3>
										<div>{progress.done} / {progress.total} devices</div>
									</div>
								</div>
							</div>
						</>}
						{view == "done" && <>
							<div className="section mt-1 mb-1">
								<div className="section mt-1 mb-1">
									<div className="card">
										<div className="card-body text-center" style={{ padding: 60 }}>
											<h3>All updates are complete!</h3>
											<ImportResultSummary summary={importSummary} />
											<Link to="/Admin/AdminProductList" className="btn btn-primary">{t('product.label.productList')}</Link>
										</div>
									</div>
								</div>
							</div>
						</>}
					</div>
				</>
			}
		</>
	);
};

const mapState = (state) => {
	return {
		companies: state.CompanyReducer.companies,
		codelist: state.RayCodeReducer.items,
		clist : state.RayCodeReducer.items,
	};
};

const mapDispatch = (dispatch) => ({
    BulkUpdateEachProductTenYearsWarranty: (list) => dispatch(ProductAction.BulkUpdateEachProductTenYearsWarranty(list)),
});

export default connect(mapState, mapDispatch)(AdminTenYears);
